import { IPanelProps, Panel } from '@fluentui/react/lib/Panel';

export interface IPPanelProps extends IPanelProps {}
export { PanelType as IPPanelType } from '@fluentui/react/lib/Panel';

export const IPPanel = (props: IPPanelProps) => {
  return <Panel {...props} />;
};
